<div class="service-row">
  <div class="nes-flex nes-items-center nes-gap-10">
    <div
      class="nes-flex nes-justify-center nes-items-center nes-rounded nes-h-12 nes-w-12 nes-bg-form-bg"
    >
      <nes-icon
        [name]="getIconName(service.url)"
        color="blue-500"
        role="presentation"
        aria-hidden="true"
      ></nes-icon>
    </div>
    <span class="service-label">
      {{
        "COMPOSE.CHOOSE_EXTRAS.SERVICES." + service.identifier + ".TITLE"
          | translate
      }}
    </span>
  </div>
  <div class="nes-flex nes-items-center nes-gap-10">
    <nes-toggle
      [nesId]="service.identifier + '_toggle'"
      [checked]="service.selected"
      (nesOnChange)="toggleSelection($event)"
      [attr.aria-label]="
        'COMPOSE.CHOOSE_EXTRAS.SERVICES.' + service.identifier + '.TITLE'
          | translate
      "
    ></nes-toggle>
  </div>
</div>
<hr class="service-separator" />
